<template>
  <CardFrame :bgColor="data.backgroundColor" :size="'small'" hasDropShadow>
    <CardContainer :size="'small'">
      <CardMediaContainer>
        <VimeoVideo
          :title="data.video.title"
          :videoId="data.video.vimeoNumber" />
      </CardMediaContainer>
      <CardHeaderContainer>
        <CardMeta>{{ data.meta }}</CardMeta>
        <Title class="text-left" :headingTag="'h3'" :style="'h3'">
          {{ data.title }}
        </Title>
      </CardHeaderContainer>
      <CardBodyContainer>
        <CardBody :textAlignment="'left'" :text="data.body"></CardBody>
      </CardBodyContainer>
    </CardContainer>
    <CardDownloadLink
      v-if="data.video.downloadLink"
      :link="data.video.downloadLink">
      Download mp4
    </CardDownloadLink>
  </CardFrame>
</template>

<script>
import CardBodyContainer from "../../Atoms/Cards/CardBodyContainer.vue";
import CardBody from "../../Atoms/Cards/CardBody.vue";
import CardContainer from "../../Atoms/Cards/CardContainer.vue";
import CardDownloadLink from "../../Atoms/Cards/CardDownloadLink.vue";
import CardFrame from "../../Atoms/Cards/CardFrame.vue";
import CardHeaderContainer from "../../Atoms/Cards/CardHeaderContainer.vue";
import CardMediaContainer from "../../Atoms/Cards/CardMediaContainer.vue";
import CardMeta from "../../Atoms/Cards/CardMeta.vue";
import Title from "../../Atoms/Heading.vue";
import VimeoVideo from "../../Atoms/VimeoVideo.vue";

import useHasSlot from "../../../compostables/useHasSlot";

export default {
  components: {
    CardBody,
    CardBodyContainer,
    CardContainer,
    CardDownloadLink,
    CardFrame,
    CardHeaderContainer,
    CardMediaContainer,
    CardMeta,
    Title,
    VimeoVideo,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  setup(props, { slots }) {
    const { hasSlot } = useHasSlot(slots);

    return {
      hasSlot,
    };
  },
};
</script>
